import { render } from "./AppRowActions.vue?vue&type=template&id=55d0d8ee"
import script from "./AppRowActions.vue?vue&type=script&lang=js"
export * from "./AppRowActions.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__